/** Toolbar orientation. `horizontal` (default) is the typical app toolbar. */
export const TOOLBAR_ORIENTATION_HORIZONTAL = 'horizontal';
export const TOOLBAR_ORIENTATION_VERTICAL = 'vertical';

export type ToolbarOrientation =
  | typeof TOOLBAR_ORIENTATION_HORIZONTAL
  | typeof TOOLBAR_ORIENTATION_VERTICAL;

/**
 * Visual treatment.
 * - `flat` (default): transparent surface — sits inside another container
 *   (e.g. a top bar) without competing for visual weight.
 * - `floating`: opaque rounded surface with elevation — lifts above the
 *   page (e.g. the editor canvas toolbar that floats over the graph).
 */
export const TOOLBAR_VARIANT_FLAT = 'flat';
export const TOOLBAR_VARIANT_FLOATING = 'floating';

export type ToolbarVariant =
  | typeof TOOLBAR_VARIANT_FLAT
  | typeof TOOLBAR_VARIANT_FLOATING;

/**
 * Surface of the `floating` variant: `surface` matches the page, `raised` is
 * one step above it (`surfaceContainerHigh`) for chips over a busy canvas.
 */
export const TOOLBAR_TONE_SURFACE = 'surface';
export const TOOLBAR_TONE_RAISED = 'raised';

export type ToolbarTone =
  | typeof TOOLBAR_TONE_SURFACE
  | typeof TOOLBAR_TONE_RAISED;

/** Density tokens — control inter-button gap. */
export const TOOLBAR_DENSITY_COMPACT = 'compact';
export const TOOLBAR_DENSITY_REGULAR = 'regular';

export type ToolbarDensity =
  | typeof TOOLBAR_DENSITY_COMPACT
  | typeof TOOLBAR_DENSITY_REGULAR;

/** Per-density inter-button gap + padding for the floating variant. */
export const TOOLBAR_DENSITY_TOKENS: Record<
  ToolbarDensity,
  { gap: string; floatingPad: string }
> = {
  [TOOLBAR_DENSITY_COMPACT]: { gap: '2px', floatingPad: '4px' },
  [TOOLBAR_DENSITY_REGULAR]: { gap: '4px', floatingPad: '6px' },
};
